module.exports = __webpack_public_path__ + "static/media/racecheck_logo_black.784955e3.svg";